import { Component, input, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-excel-button',
    imports: [ButtonModule],
    templateUrl: './excel-button.component.html',
    styleUrl: './excel-button.component.scss'
})
export class ExcelButtonComponent {
    data = input<any[]>([]);
    excelTitle = input<string>('');
    columns = input<{ key: string; label: string }[]>([]);

    onExportExcel() {
        if (!this.data() || this.data().length === 0 || this.columns().length === 0) return;
        const headers = this.columns().map((col) => col.label);
        const rows = this.data().map((row) => this.columns().map((col) => row[col.key] ?? ''));
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `${this.excelTitle()}.xlsx`);
    }
}
